// extracted by mini-css-extract-plugin
export default {"links_wrap":"NewsAsideItemControl_links_wrap__v+9M7","next":"NewsAsideItemControl_next__gyF1Y","prev":"NewsAsideItemControl_prev__vrtWn"};